module.exports = __webpack_public_path__ + "assets/blog/images/kursus-bilagshaandtering.webp";